<template>
  <div class="logo-wrapper">
    <a
      v-if="site === 'b2b'"
      class="d-block pointer-on -add-focus-box"
      :href="linkTo(`b2b/?customerId=${customerId}`)"
    >
      <B2BLogo />
    </a>
    <a v-else class="d-block pointer-on -add-focus-box" aria-label="Back to front page" :href="linkTo('')">
      <BrandLogo />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const B2BLogo = () => import('@/Scripts/components/layout/logo/B2BLogo.vue');
const BrandLogo = () => import(/* webpackChunkName: "BrandLogo" */'@/Scripts/components/layout/logo/BrandLogo.vue');
export default {
  name: 'LogoController',
  components: {
    BrandLogo,
    B2BLogo
  },
  props: {
    site: {
      type: String,
      default: 'b2c'
    }
  },
  computed: {
    ...mapState({
      customerId: state => state.b2bCustomer.customerId
    })
  },
  methods: {
    linkTo: function (link) {
      return `/${document
        .getElementsByTagName('html')[0]
        .getAttribute('lang')}/${link}`;
    }

  }

};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";
.logo-wrapper {
  @include media-breakpoint-down(md) {
    margin-bottom: 0;
  }
}
</style>
